import Icon from '../components/Icon.vue'

Icon.register({"couch":{"width":640,"height":512,"paths":[{"d":"M160 224V288H480V224C480 188.7 508.7 160 544 160H576C576 107 533 64 480 64H160C107 64 64 107 64 160H96C131.3 160 160 188.7 160 224zM576 192H544C526.3 192 512 206.3 512 224V320H128V224C128 206.3 113.7 192 96 192H64C28.7 192 0 220.7 0 256 0 279.6 13 300 32 311.1V432C32 440.8 39.2 448 48 448H112C120.8 448 128 440.8 128 432V416H512V432C512 440.8 519.2 448 528 448H592C600.8 448 608 440.8 608 432V311.1C627 300 640 279.6 640 256 640 220.7 611.3 192 576 192z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/couch.js
// module id = null
// module chunks = 